import { TermsBody, PrivacyBody } from '../components/LegalModal';

/**
 * Public, unauthenticated Terms / Privacy pages. Reuse the same bodies the
 * registration LegalModal renders (off the `legal` i18n namespace), but at
 * stable public URLs (/terms, /privacy) — required for the Google OAuth
 * consent screen's privacy-policy and terms-of-service links, and generally
 * good practice. Reachable without a session (mounted in App's Root, before
 * the auth Gate).
 */
export default function LegalPage({ doc }: { doc: 'terms' | 'privacy' }) {
  return (
    <main className="legal-page">
      <div className="legal-page-inner">
        {doc === 'terms' ? <TermsBody /> : <PrivacyBody />}
      </div>
    </main>
  );
}
